var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 335,
    viewBox: "0 0 387 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 0L387 19L344.5 297.5L0 335L135 0Z",
    fill: "#00BA80"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.920a0bfb13ed56d4403511753c448daf.svg";
export { ForwardRef as ReactComponent };